<template>
    <div class="maincontainer">
        <table>
            <thead style="position: sticky; top: 100px;">
                <tr>
                    <th style="width: 1%;" v-if="role == 'ddd_admin' || (role == 'ddd_worker')"></th>
                    <th>
                        <p v-on:click="set_order('date')" class="cursor-pointer">
                            <span>{{$t('installations.datecreated')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'date' && order == 'desc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'date' && order == 'asc'">arrow_drop_up</i>
                        </p>
                        <select v-model="rangeSelected">
                            <option value="currentMonth">{{$t('calendar.current_month')}}</option>
                            <option value="prevMonth">{{$t('calendar.prev_month')}}</option>
                            <option value="lastThreeMonths">{{$t('calendar.last_three_months')}}</option>
                            <option value="currentYear">{{$t('calendar.current_year')}}</option>
                            <option value="prevYear">{{$t('calendar.previous_year')}}</option>
                            <option value="other">{{$t('calendar.other_range')}}</option>
                        </select>
                        <div class="row" v-if="rangeSelected == 'other'">
                            <div class="col s6 input-field" style="padding-left: 0px;padding-right: 5px; min-width: 13ch;">
                                <input type="date" v-model="fromSelected" />
                                <button class="waves-effect waves-light btn-large gray" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px;padding-right: 0px; width: 100%" v-on:click="cancelChanges()">{{$t('calendar.cancel')}}</button>
                            </div>
                            <div class="col s6 input-field" style="padding-right: 5px;padding-left: 5px; min-width: 13ch;">
                                <input type="date" v-model="toSelected" />
                                <button class="waves-effect waves-light btn-large green" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px;padding-right: 0px; width: 100%" v-on:click="applyChanges()">{{$t('calendar.apply')}}</button>
                            </div>
                        </div>
                    </th>
                    <th>
                         <p v-on:click="set_order('place_name')" class="cursor-pointer">
                            <span>{{$t('installations.place_name')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'desc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'asc'">arrow_drop_up</i>
                        </p>
                        <div class="input-field col s6"><input v-model="customersearch" /></div>
                    </th>
                    <th>
                        <p v-on:click="set_order('kinds')" class="cursor-pointer">
                            <span>{{$t('installations.type_procedures')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'kinds' && order == 'desc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'kinds' && order == 'asc'">arrow_drop_up</i>
                        </p>
                        <selector v-model="selected_kinds" :items="kinds" identifier="kinds"></selector>
                    </th>
                    <th>
                        <p v-on:click="set_order('worker_name')" class="cursor-pointer">
                            <span>{{$t('installations.worker')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'worker_name' && order == 'desc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'worker_name' && order == 'asc'">arrow_drop_up</i>
                        </p>
                        <template v-if="loaded">
                            <selector v-model="workers" :items="workerslist" identifier="workers"></selector>
                        </template>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <template v-for="(installation, index) in listItems">
                    <tr :key="installation.id">
                        <td v-if="role == 'ddd_admin' || (role == 'ddd_worker')">
                            <colorselector :color="installation.color" v-on:colorSelected="changeColor(installation, $event)"/>
                        </td>
                        <td>{{installation.date | formatDate}}</td>
                        <td  @dblclick="showInstallation(installation)" style="cursor: pointer;">{{installation.place_name}}</td>
                        <td>{{name_kinds(installation.kinds)}}</td>
                        <td>{{installation.worker}}</td>
                        <td><router-link :to='"/customers/"+installation.customer_id+"/places/"+installation.place_id+"/installations/" + installation.id'><i class="material-icons dp6">list_alt</i></router-link></td>
                    </tr>
                </template>
            </tbody>
            <preloader v-if="loaded == false" n="4" />
        </table>
        <template v-if="listItems.length == 0 && loaded">
            <p style="font-size: 12px;">{{$t('installations.not_found')}}</p>
        </template>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import moment from 'moment';
export default {
    data: function() {
        return {
            order: 'desc',
            orderby: 'date',
            customersearch: "",
            workerslist: [],
            workers: [],
            rangeSelected: "currentMonth",
            lastRange: "currentMonth",
            from: moment().startOf("month").format("YYYY-MM-DD"),
            to: moment().endOf("month").format("YYYY-MM-DD"),
            fromSelected: moment().startOf("month").format("YYYY-MM-DD"),
            toSelected: moment().endOf("month").format("YYYY-MM-DD"),
            kinds: [
                { name: this.$t('installations.system_enter'), value: "system_mount" },
                { name: this.$t('installations.installation'), value: "physical_mount" },
                { name: this.$t('installations.exchange'), value: "replaced" }
            ],
            selected_kinds: [],
            places: [],
            colors: [ "white", "red", "green", "orange", "blue", "yellow", "violet", "gray", "black" ],
            loaded: false
        }
    },
    props: { role: String, extended_privileges: Boolean },
    watch: {
        rangeSelected: function(val) {
            if (val == "currentMonth") {
                this.lastRange = val;
                this.from = moment().startOf("month").format("YYYY-MM-DD")
                this.fromSelected = moment().startOf("month").format("YYYY-MM-DD")
                this.to = moment().endOf("month").format("YYYY-MM-DD")
                this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
            } else if (val == "prevMonth") {
                this.lastRange = val;
                this.from = moment().subtract(1, 'months').startOf("month").format("YYYY-MM-DD")
                this.fromSelected = moment().subtract(1, 'months').startOf("month").format("YYYY-MM-DD")
                this.to = moment().subtract(1, 'months').endOf("month").format("YYYY-MM-DD")
                this.toSelected = moment().subtract(1, 'months').endOf("month").format("YYYY-MM-DD")
            } else if (val == "lastThreeMonths") {
                this.lastRange = val;
                this.from = moment().subtract(3, 'months').startOf("month").format("YYYY-MM-DD")
                this.fromSelected = moment().subtract(3, 'months').startOf("month").format("YYYY-MM-DD")
                this.to = moment().endOf("month").format("YYYY-MM-DD")
                this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
            } else if (val == "currentYear") {
                this.lastRange = val;
                this.from = moment().startOf("year").format("YYYY-MM-DD")
                this.fromSelected = moment().startOf("year").format("YYYY-MM-DD")
                this.to = moment().endOf("year").format("YYYY-MM-DD")
                this.toSelected = moment().endOf("year").format("YYYY-MM-DD")
            } else if (val == "prevYear") {
                this.lastRange = val;
                this.from = moment().subtract(1, 'years').startOf("year").format("YYYY-MM-DD")
                this.fromSelected = moment().subtract(1, 'years').startOf("year").format("YYYY-MM-DD")
                this.to = moment().subtract(1, 'years').endOf("year").format("YYYY-MM-DD")
                this.toSelected = moment().subtract(1, 'years').endOf("year").format("YYYY-MM-DD")
            }
            this.fetch_items(moment(this.from), moment(this.to));
        },
    },
    beforeRouteLeave (to, from , next) {
        this.$emit('commitState', { 
          installations: {
            kinds: this.selected_kinds,
            rangeSelected: this.rangeSelected,
            customersearch: this.customersearch,
            order: this.order,
            orderBy: this.orderBy,
            from: this.from,
            to: this.to,
            workers: this.workers
          },
          page: 'installations' }
        );
        next();
    },
    mounted(){
        var state = this.$parent.state;
        if(state.installations != undefined) {    
            this.selected_kinds = state.installations.kinds;
            this.rangeSelected = state.installations.rangeSelected;
            this.customersearch = state.installations.customersearch;
            this.order = state.installations.order;
            this.orderBy = state.installations.orderBy;
            this.from = state.installations.from;
            this.fromSelected = state.installations.from;
            this.to = state.installations.to;
            this.toSelected = state.installations.to;
            this.workers = state.installations.workers;
        }else{
            axios.get('/installations/last.json').then(response => {
                var last_time = moment(response.data * 1000);
                if (last_time.isBetween(moment().startOf("month"), moment().endOf("month"))) that.rangeSelected = "currentMonth";
                else if (last_time.isBetween(moment().subtract(1, 'months').startOf("month"), moment().subtract(1, 'months').endOf("month"))) that.rangeSelected = "prevMonth";
                else if (last_time.isBetween(moment().subtract(3, 'months').startOf("month"), moment().endOf("month"))) that.rangeSelected = "lastThreeMonths";
                else if (last_time.isBetween(moment().startOf("year"), moment().endOf("year"))) that.rangeSelected = "currentYear";
                else if (last_time.isBetween(moment().subtract(1, 'years').startOf("year"), moment().subtract(1, 'years').endOf("year")))
                    that.rangeSelected = "prevYear";
                else {
                    that.from = last_time.clone().startOf("month").format("YYYY-MM-DD")
                    that.fromSelected = last_time.clone().startOf("month").format("YYYY-MM-DD")
                    that.to = last_time.clone().endOf("month").format("YYYY-MM-DD")
                    that.toSelected = last_time.clone().endOf("month").format("YYYY-MM-DD")
                    that.rangeSelected = "other";
                }
                that.loaded = true;
            });
            }
        var that = this;
        this.fetch_items(moment(that.from), moment(that.to));
    },
    methods: {
        fetch_items: function(a, b) {
            this.loaded = false;
            axios.get('/installations/' + a.unix() + '/' + b.endOf('day').unix() + '.json').then(response => {
                this.places = response.data;
                this.loaded = true;
                this.workerslist = []
                for (var i in this.places) {

                    if (this.places[i].worker != null) this.workerslist = _.uniq(_.union(this.workerslist, [this.places[i].worker]))
                }
                this.workerslist = _.map(this.workerslist, worker => {
                    return { name: worker, value: worker }
                })
            })
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }
            } else {
                this.orderby = order;
            }
        },
        applyChanges: function(){
          this.from = this.fromSelected;
          this.to = this.toSelected;
          this.fetch_items(moment(this.from), moment(this.to))
        },
        name_kinds: function(kinds) {
            var out = ""
            for (var i = kinds.length - 1; i >= 0; i--) {
                out += { "replaced": this.$t('installations.exchange'), "physical_mount": this.$t('installations.installation'), "system_mount": this.$t('installations.system_enter') } [kinds[i]] + " "
            }
            return out;
        },
        showInstallation: function(installation){
            this.$router.push("/customers/"+installation.customer_id+"/places/"+installation.place_id+"/installations/" + installation.id)
        },
        changeColor: function(inter, value){
            axios.put("/installations/"+inter.id+".json", {color: value});
            inter.color = value;
        }
    },
    computed: {
        listItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.places, this.orderby, this.order),
                function(item) {
                    return (_.includes(that.workers, item.worker) || that.workers.length == 0) && item.place_name.toUpperCase().indexOf(that.customersearch.toUpperCase()) >= 0 && (_.intersection(that.selected_kinds, item.kinds).length > 0 || that.selected_kinds.length == 0)
                }
            );
        },
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    margin: 0em;
}

nav {
    background-color: #626262;
    height: 'desc''asc'px;
}

nav a {
    margin: 'desc'5px;
}

thead {
    background-color: #DADADA;
}

thead th {
    font-weight: 300;
    padding-top: 5px;
    padding-bottom: 5px;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

.maincontainer {
    padding-top: 33px;
    margin: 33px;
}

select {
    display: block;
    padding-top: 0px;
    padding-bottom: 0 0 0 0;
    height: 35px;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
}
th span {
  padding-left: 5px!important;
}
td{
  padding-left: 15px!important;
}
.star{
    -webkit-text-stroke: black;
    -webkit-text-stroke-width: 1px;
    user-select: none;
}
</style>